let Utils = {

    noop: function () {
    },

    each: function (obj, cb) {
        let type = Utils.type(obj);
        let i;
        let len;

        if (type === 'array') {
            for (i = 0, len = obj.length; i < len; i++) {
                if (cb.call(obj[i], obj[i], i) === false) {
                    break;
                }
            }
        } else {
            for (i in obj) {
                if (obj.hasOwnProperty(i)) {
                    if (cb.call(obj[i], obj[i], i) === false) {
                        break;
                    }
                }
            }
        }
    },

    type: function (s) {
        return Object.prototype.toString.call(s).slice(8, -1).toLowerCase();
    },

    extend: function () {
        let args = Array.prototype.slice.call(arguments);
        let targetObj = args.shift() || {};

        Utils.each(args, function (item) {
            Utils.each(item, function (value, key) {
                targetObj[key] = value;
            });
        });

        return targetObj;
    },

    clone: function (obj) {
        return obj ? JSON.parse(JSON.stringify(obj)) : obj;
    },

    pick: function (obj, keyList) {
        let result = {};

        Utils.each(keyList, function (key) {
            result[key] = obj[key];
        });

        return result;
    },

    objToParams: function (obj, prefrex) {
        let list = [];
        let result;

        Utils.each(obj, function (v, k) {
            list.push(k + '=' + encodeURIComponent(v));
        });

        result = list.join('&');

        if (prefrex && result) {
            result = '?' + result;
        }

        return result;
    },

    // 美化时间输入
    niceTime: function (timeStamp) {
        let date, now, deltaTime;

        if (!timeStamp) {
            return '';
        }

        now = new Date();
        date = new Date(timeStamp);
        deltaTime = (now.getTime() - date.getTime()) / 1000;

        if (deltaTime < 60) {
            return '刚刚';
        } else if (deltaTime < 3600) {
            return parseInt(deltaTime / 60) + '分钟前';
        } else if (deltaTime < 3600 * 24) {
            return parseInt(deltaTime / 3600) + '小时前';
        } else if (date.getFullYear() === now.getFullYear()) {
            return Utils.date(timeStamp, 'yyyy.MM.dd');
        }

        return Utils.date(timeStamp, 'yyyy.MM.dd');
    },

    date: function (timeStamp, format) {
        format = format || "yy-MM-dd HH:mm:ss";
        let week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
        let date = new Date(timeStamp);

        let o = {
            "M+": date.getMonth() + 1,
            "d+": date.getDate(),
            "h+": date.getHours() % 12,
            "H+": date.getHours(),
            "m+": date.getMinutes(),
            "s+": date.getSeconds(),
            "q+": Math.floor((date.getMonth() + 3) / 3),
            "S+": date.getMilliseconds(),
            "W+": week[date.getDay()]
        };

        if (/(y+)/.test(format))
            format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));

        for (let k in o)
            if (new RegExp("(" + k + ")").test(format))
                format = format.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));

        return format;
    },

    formatNum2: function (num) {
        if (num > 9) {
            return num + '';
        }

        return '0' + num;
    },

    // 对比两个日期串,
    compareDateString: function (date1, date2) {
        let day1 = parseInt(date1.replace(/-|\s|:/g, ''));
        let day2 = parseInt(date2.replace(/-|\s|:/g, ''));

        return day1 - day2;
    },

    getByLevelKey: function (target, key) {
        let keyList, len, i;

        if (!target || typeof target !== 'object') {
            return undefined;
        }

        keyList = key.toString().split('.');

        for (i = 0, len = keyList.length; i < len; i++) {
            target = target[keyList[i]];

            if (i < len - 1 && (typeof target !== 'object' || !target)) {
                return undefined;
            }
        }

        return target;
    },

    parseDuring: function (during, level = 2) {
        let hour, mins, secs;

        hour = mins = secs = 0;

        during = Math.ceil(during);

        if (level === 3) {
            hour = parseInt(during / 3600);
            mins = parseInt((during - 3600 * hour) / 60);
        }
        else {
            mins = parseInt(during / 60);
        }

        secs = parseInt(during - 3600 * hour - 60 * mins);

        if (hour < 10) {
            hour = '0' + hour;
        }

        if (mins < 10) {
            mins = '0' + mins;
        }
        if (secs < 10) {
            secs = '0' + secs;
        }

        return (level === 3 ? (hour + ':') : '') + mins + ':' + secs;
    },

    debounce: function (func, waiting) {
        let delayTimer;

        waiting = waiting || 20;

        return function () {
            let that = this;
            let args = [].slice.call(arguments, 0);

            if (delayTimer) {
                clearTimeout(delayTimer);
            }

            delayTimer = setTimeout(function () {
                func.apply(that, args);

                delayTimer = null;
            }, waiting);
        };
    },

    find: function (target, name, value) {
        let isFun = typeof name === 'function';
        let result;

        for (let i = 0, len = target.length; i < len; i++) {
            if (isFun) {
                if (name(target[i]) === true) {
                    return target[i];
                }
            }
            else {
                if (target[i][name] == value) {
                    return target[i];
                }
            }
        }

        return result;
    },

    findIndex: function (target, name, value) {
        let isFun = typeof name === 'function';
        let result = -1;

        for (let i = 0, len = target.length; i < len; i++) {
            if (isFun) {
                if (name(target[i]) === true) {
                    return i;
                }
            }
            else {
                if (target[i][name] == value) {
                    return i;
                }
            }
        }

        return result;
    },

    listToMap: function (list, keyName, valueName) {
        let result = {};

        list.forEach(item => {
            result[item[keyName || 'id']] = valueName ? item[valueName] : item;
        });

        return result;
    },

    mapToList: function (mapObj, keyName = 'id', valueName = 'value') {
        let result = [];

        Utils.each(mapObj, (value, name) => {
            let obj = {};

            obj[keyName] = name;
            obj[valueName] = value;

            result.push(obj);
        });

        return result;
    },

    unionId: function (prefix) {
        if (!Utils.unionId.__autoNum) {
            Utils.unionId.__autoNum = 1;
        }

        return (prefix || '') + (Utils.unionId.__autoNum++);
    },

    testEmoj: function (str) {
        let regRule = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g;
        let ret = str.match(regRule);

        if (ret) {
            return ret.length;
        }

        return 0;
    },

    clearEmoj: function (str) {
        if (!str) {
            return '';
        }

        return str.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, "");
    },

    searchToObject: function (searchString) {

        let result = {};

        if (!searchString) {
            return result;
        }

        try {
            searchString = decodeURIComponent(searchString);
        } catch (e) {
            //
        }

        searchString = searchString.replace(/^\?/, '');

        let sps = searchString.split('&');

        for (let i = 0, len = sps.length; i < len; i++) {
            let sps2 = sps[i].split('=');

            result[sps2[0]] = sps2[1];
        }

        return result;

    },

    toFixed: function (num, aft = 2) {

        let bei = Math.pow(10, aft);

        return parseInt(num * bei) / bei;

    },

    formatLargeNum: function (num) {

        // 100w
        if (num >= 1000000) {
            return parseInt(num / 10000) + '万';
        }

        // 10w
        if (num >= 100000) {
            return Utils.toFixed(num / 10000, 1) + '万';
        }

        return num;

    },

    replaceAllTags(html, subLength) {
        return html.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').substr(0, subLength);
    },

    substr(string, length) {
        if (string.length <= length) {
            return string;
        }

        return string.substr(0, length) + '...';
    },

    // 填充一个数组，使之以指定的列数填满
    fillAsFullRow: function (list, colCount) {
        const left = colCount - list.length % colCount;

        if (colCount === left) {
            return list;
        }

        for (let i = 0; i < left; i++) {
            list.push({id: Math.random()});
        }

        return list;
    }

};

//格式化字符串
Utils.stringFormat = function () {
    if (arguments.length == 0)
        return null;
    let str = arguments[0];

    for (let i = 1; i < arguments.length; i++) {
        let re = new RegExp('\\{' + (i - 1) + '\\}', 'gm');
        str = str.replace(re, arguments[i]);
    }

    return str;
};

Utils.getRandomFromArray = function (list) {
    return list[parseInt(Math.random() * list.length)];
};

Utils.getQuery = function () {
    return Utils.searchToObject(location.search.substr(1))
};

// 取随机字符串
const randomCharList = '0123456789abcdefghijklmnopqrstuvwxyz'.split('');

Utils.getRandomChar = function (len = 1) {
    let result = [];

    for (let i = 0; i < len; i++) {
        result.push(Utils.getRandomFromArray(randomCharList));
    }

    return result.join('');
};

Date.prototype.format = function (format) {

    let k;
    let week = ['日', '一', '二', '三', '四', '五', '六'];

    let o = {
        'M+': this.getMonth() + 1,
        'd+': this.getDate(),
        'h+': this.getHours() % 12,
        'H+': this.getHours(),
        'm+': this.getMinutes(),
        's+': this.getSeconds(),
        'q+': Math.floor((this.getMonth() + 3) / 3),
        'S+': this.getMilliseconds(),
        'W+': week[this.getDay()]
    };

    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
    }

    for (k in o) {
        if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
        }
    }

    return format;

};


const urlSps = location.href.replace(/#.*$/, '').replace(/\?.*$/, '').split('/');

Utils.getPageUrl = function (page, params) {
    const sps2 = urlSps.slice(0, -1);
    sps2.push(page + '.html');
    return sps2.join('/') + Utils.objToParams(params, true);
}

Utils.isRecommendLink = function (item) {
    return !!(item && item.link);
};

Utils.getRecommendHref = function (item) {
    if (!item) {
        return '';
    }
    if (item.link) {
        return item.link;
    }
    return Utils.getPageUrl('detail', {id: item.id});
};

Utils.getRecommendTarget = function (item) {
    if (item && item.link) {
        return item.openNewWindow === false ? '_self' : '_blank';
    }
    return '_blank';
};

Utils.getPageFromUrl = function (){
    return location.href.replace(/#.*$/, '').replace(/\?.*$/, '').split('/').pop().replace('.html', '').split('-').pop();
}

export default Utils;
